import {
  QUIZ_GROUP_MIN_TERM,
  QUIZ_GROUP_MIN_USERS,
  type QuotePlanType,
} from '../constants/quizQuote.const';

/** 그룹 요금제 조건에 1스텝 근접했을 때 노출하는 유도 문구. */
export const UPSELL_ADD_USER = '1명만 추가하면 더 저렴하게 이용할 수 있어요.';
export const UPSELL_EXTEND_TERM =
  '1개월만 늘리면 더 저렴하게 이용할 수 있어요.';

export interface QuoteUpsellInput {
  planType: QuotePlanType;
  term: number;
  userCount: number;
}

/**
 * 개인 요금제로 선택했지만 학교·단체(그룹) 할인 조건(최소 5인·3개월)에
 * "딱 1스텝" 모자란 경우 유도 배너 문구를 반환한다. 해당 없으면 null.
 * - 기간은 충족(≥3개월)·인원만 1명 부족(4명) → 인원 추가 유도
 * - 인원은 충족(≥5명)·기간만 1개월 부족(2개월) → 기간 연장 유도
 */
export function getUpsellMessage({
  planType,
  term,
  userCount,
}: QuoteUpsellInput): string | null {
  if (planType !== 'individual') return null;

  if (term >= QUIZ_GROUP_MIN_TERM && userCount === QUIZ_GROUP_MIN_USERS - 1) {
    return UPSELL_ADD_USER;
  }
  if (term === QUIZ_GROUP_MIN_TERM - 1 && userCount >= QUIZ_GROUP_MIN_USERS) {
    return UPSELL_EXTEND_TERM;
  }
  return null;
}
